import React from 'react';
import { BaseImage, SanityBlock, SanityKeyed, TagsLineV2 } from 'types/studio/studio';
import CustomPortableText from 'shared/studio/PortableText/PortableText';
import { Typography, getTypographyDefaultColor } from '@ag1/ui';
import { StudioBaseIconV2 } from 'shared/studio/StudioBaseIcon/StudioBaseIcon';
import styles from './TagCustom.module.scss';

type TagCustomProps = {
  icon: BaseImage | undefined;
  text: Array<SanityKeyed<SanityBlock>>;
};

const TagCustom = ({
  icon,
  text,
  theme
}: Pick<TagsLineV2, 'bgColor' | 'theme'> & TagCustomProps) => (
  <div className={styles.tag}>
    {icon && <StudioBaseIconV2 icon={icon} className={styles.icon} />}
    {text && (
      <Typography
        component="div"
        variant="headlineSans"
        size="3"
        weight="400"
        noPadding
        className={styles.text}
        color={getTypographyDefaultColor(theme)}>
        <CustomPortableText value={text} />
      </Typography>
    )}
  </div>
);

export default TagCustom;
